const Event404 = () => {
    return <h1 className="text-3xl font-bold text-gray-800 text-center mt-20">
        Aucune information suplémentaire pour cet événement.
    </h1>
};
  
export default Event404;